import React, { Component } from 'react';
import './accordion.scss';
import '../Dashboard/HowToFundPopup/dropDown.scss';
import { joinClasses } from '../../utils/helpers';

/** @import {AccordionProps, AccordionLinkProps, AccordionItemProps, AccordionItemState} from './AccordionTypes' */

/** @extends {Component<AccordionItemProps, AccordionItemState>} */
export class AccordionItem extends Component {
    /** @type {React.RefObject<HTMLInputElement>} */
    inputRef = React.createRef();

    onClick = (/** @type {React.MouseEvent<HTMLLabelElement, MouseEvent>} */ event, /** @type {((id: string) => void) | undefined} */ onClick, /** @type {string} */ item) => {
        event.preventDefault();

        if (this.props.onToggle) {
            this.props.onToggle();
        }

        if (onClick && this.inputRef.current && !this.inputRef.current.checked)
            onClick(item);

        if (this.props.onExpand) this.props.onExpand({ target: this.inputRef.current });
    }

    render() {
        const { id, onClick, classOverride, item, product, featureEnabled, isOpen } = this.props;
        const anchorId = item.anchorId ? item.anchorId : '';
        const activeClass = isOpen ? 'active' : '';

        return (
            <>
                <div id={anchorId}>
                    <label 
                        htmlFor={id} 
                        className={joinClasses('accordion__item-wrapper', classOverride + '__item-wrapper')} 
                        onClick={(/** @type {React.MouseEvent<HTMLLabelElement, MouseEvent>} */ event) => this.onClick(event, onClick, item.title)}>
                        <input
                            ref={this.inputRef}
                            name={classOverride}
                            id={id}
                            type='radio'
                            className={joinClasses('accordion__input', classOverride + '__input')}
                            checked={isOpen}
                            onChange={() => {}}
                        />
                        <div className={joinClasses('accordion__item', classOverride + '__item')}>
                            <p className={joinClasses('accordion__title', classOverride + '__title', activeClass)}>
                                {item.title}
                            </p>
                            <div className={joinClasses('accordion__body', classOverride + '__body')}>
                                {product 
                                    // @ts-expect-error I don't think this line ever runs
                                    ? item.body(product, featureEnabled) 
                                    : item.body}
                            </div>
                        </div>
                    </label>
                </div>
            </>
        );
    }
}

function Accordion(/** @type {AccordionProps} */ { items, onExpand, classOverride, openFirst, product, featureEnabled }) {
    const [openIndex, setOpenIndex] = React.useState(openFirst ? 0 : -1);

    const handleToggle = (index) => {
        setOpenIndex((prevIndex) => prevIndex === index ? -1 : index);
    };

    return (
        <ul className={joinClasses(classOverride, 'accordion')}>
            {items.map((item, i) => (
                <li key={i}>
                    <AccordionItem 
                        item={item} 
                        product={product} 
                        featureEnabled={featureEnabled}
                        id={`accordion-${i}`} 
                        onExpand={onExpand} 
                        defaultOpen={Boolean(openFirst && i === 0)} 
                        classOverride={classOverride}
                        isOpen={openIndex === i}
                        onToggle={() => handleToggle(i)}
                    />
                </li>
            ))}
        </ul>
    );
};

export function AccordionLink(/** @type {AccordionLinkProps} */ props) {
    const onClick = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ e) => {
        e.stopPropagation();
    };

    return (
        <a href={props.href} target={props.target} onClick={onClick}>
            {props.children}
        </a>
    );
};

export default Accordion;
